import React from 'react';
import NewsletterSignup from '../../../newsletter/newsletter';
import { commonStyles, colors } from '../styles/minimalStyles'; // Adjust path

const styles = {
  newsletterWrapper: {
    // Example: Add background or padding if needed
    padding: '40px 0', // Vertical padding
    marginBottom: commonStyles.section.marginBottom, // Use consistent spacing
  },
   // You might need a container inside if NewsletterSignup doesn't center itself
  // contentContainer: {
  //    ...commonStyles.container
  // }
};

// This component primarily acts as a styled wrapper if needed.
// If NewsletterSignup is self-contained and styled, this might be simpler.
const NewsletterSection = () => {
  return (
    <div style={styles.newsletterWrapper}>
      {/* <div style={styles.contentContainer}> */}
        {/* Optional Title: */}
        {/* <h2 style={{...commonStyles.sectionTitle, borderBottom: 'none', textAlign: 'center'}}>Stay Updated</h2> */}
        <NewsletterSignup />
      {/* </div> */}
    </div>
  );
};

export default NewsletterSection;